// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2D8IW","Logo":"Toolbar_Logo__3PH56","DesktopOnly":"Toolbar_DesktopOnly__2dQWa"};